import _get from 'lodash/get';
import {
  SsoIntegration,
  SsoIntegrationProviderPresetEnum,
} from 'graphql-common';
import getSsoProviderIcon from '@lib/utils/sso/getSsoProviderIcon';

export default function getSsoIconSrc(item: SsoIntegration): string {
  const isCustomWithIcon =
    item.providerPreset === SsoIntegrationProviderPresetEnum.Custom &&
    item.icon?.urls;
  if (isCustomWithIcon) {
    return (
      _get(item, 'icon.urls.small') ||
      _get(item, 'icon.urls.medium') ||
      _get(item, 'icon.urls.original') ||
      getSsoProviderIcon(item.providerPreset)
    );
  }
  return getSsoProviderIcon(item.providerPreset);
}
